module.exports = __webpack_public_path__ + "img/1F1F7-1F1FA.2b86f498.svg";